const data = {
  'signup.heading': 'Create Your Account',
  'signup.subheading': 'Enter your details below',
  'signup.buttonText': 'Sign Up',
  'signup.email.heading': 'EMAIL ADDRESS',
  'signup.email.placeholder': 'Enter your email address',
  'signup.name.heading': 'NAME',
  'signup.name.placeholder': 'Enter your name',
  'signup.phone.heading': 'PHONE NUMBER',
  'signup.phone.placeholder': 'Enter your phone number',
  'signup.oldUser.message': 'Already have an account? ',
  'signup.oldUser.signinText': 'Sign In',
  'signup.submitText': 'Sign Up',
}

export default data
